import { render, staticRenderFns } from "./addShareReading.vue?vue&type=template&id=f04e30f8&scoped=true"
import script from "./addShareReading.vue?vue&type=script&lang=js"
export * from "./addShareReading.vue?vue&type=script&lang=js"
import style0 from "./addShareReading.vue?vue&type=style&index=0&id=f04e30f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04e30f8",
  null
  
)

export default component.exports